import { ERR_MSGS } from '../../../constants';
import { getAgeFieldId, isControl } from '../../../utils';
import { removeLocalItem, setLocalItem } from '../../store/localStore';
// Hide and show the add more button
function showAddMore() {
    const displayMore = document.getElementById('age-groups__more-field');
    displayMore.classList.remove('hidden');
    displayMore.classList.add('flex');
}
function hideAddMore() {
    const displayMore = document.getElementById('age-groups__more-field');
    displayMore.classList.add('hidden');
    displayMore.classList.remove('flex');
}
// this will handle the add event listnet to generate fields button
export function ageManager(form) {
    var _a;
    (_a = document
        .getElementById('age-groups__more-field')) === null || _a === void 0 ? void 0 : _a.addEventListener('click', () => {
        generateMoreFields(form);
    });
}
// this is a field generator for the age groups
export function generateMoreFields(form) {
    const ageGroupsContainer = document.querySelector('.age-groups');
    if (ageGroupsContainer.children.length >= 8) {
        hideAddMore();
        return;
    }
    if (ageGroupsContainer.childElementCount >= 7) {
        hideAddMore();
    }
    else {
        showAddMore();
    }
    ageGroupsContainer.appendChild(createField(form, 'Special'));
}
const ageErrrBox = document.querySelector(isControl()
    ? '.qq-packages-type--control .error__message'
    : '.qq-packages-type--variant .error__message');
function UpdateAgeFields(field, form) {
    let value = field.value;
    // Check if the field's value is a valid string number (including '0')
    if (!isNaN(Number(value)) && value !== '') {
        form.set(field.id, value);
        setLocalItem(field.id, value);
    }
    else {
        // If the field is empty or not a valid number, remove it from the form
        removeField(field.id, form);
    }
    updateGroupCount(form);
}
// add event listners for the age fields
export function watchAgeFields(form, newField) {
    const ageFields = document.querySelectorAll('.age-groups__input');
    if (newField) {
        newField.addEventListener('input', () => {
            UpdateAgeFields(newField, form);
        });
    }
    else {
        ageFields.forEach((field) => {
            field.addEventListener('input', () => {
                UpdateAgeFields(field, form);
            });
        });
    }
}
export function displayAgeFields(form, groupType) {
    var _a, _b;
    const ageGroupsContainer = document.querySelector('.age-groups');
    const currentFieldCount = ageGroupsContainer.children.length;
    if (groupType == 'IND') {
        if (currentFieldCount == 1)
            return;
        else {
            while (ageGroupsContainer.childElementCount != 1) {
                const lastChildId = (_a = ageGroupsContainer.lastChild.querySelector('input')) === null || _a === void 0 ? void 0 : _a.id;
                if (lastChildId) {
                    removeField(lastChildId, form);
                }
                ageGroupsContainer.removeChild(ageGroupsContainer.lastChild);
            }
        }
        hideAddMore();
    }
    else if (groupType == 'CPL') {
        hideAddMore();
        if (currentFieldCount == 2)
            return;
        if (currentFieldCount > 2) {
            while (ageGroupsContainer.childElementCount != 2) {
                const lastChildId = (_b = ageGroupsContainer.lastChild.querySelector('input')) === null || _b === void 0 ? void 0 : _b.id;
                if (lastChildId) {
                    removeField(lastChildId, form);
                }
                ageGroupsContainer.removeChild(ageGroupsContainer.lastChild);
            }
        }
        else {
            while (ageGroupsContainer.childElementCount != 2) {
                ageGroupsContainer.appendChild(createField(form));
            }
        }
    }
    // family and group plan should be two or more
    else {
        if (currentFieldCount < 2) {
            while (ageGroupsContainer.childElementCount < 2) {
                ageGroupsContainer.appendChild(createField(form));
            }
        }
        showAddMore();
        if (currentFieldCount >= 8) {
            hideAddMore();
        }
    }
}
function removeField(Id, form) {
    form.remove(Id);
    removeLocalItem(Id);
}
function createField(form, type = 'Normal') {
    const container = document.createElement('div');
    const elementId = getAgeFieldId();
    if (type === 'Normal') {
        container.classList.add('age-groups__field-container');
        container.innerHTML = `
    <div class="">
    <label class="text-darkblue font-semibold">
      <p class="mb-3 touch-none">Inserisci l'età</p>
    </label>
    <div class="flex">
      <div class="relative flex-1">
        <input id="${elementId}" 
        autocomplete="off" 
        name="coverageType" 
        placeholder="Inserisci l'età" 
        class="font-semibold py-3 px-4 rounded-md border-2 border-[#00000033] outline-none w-full placeholder:text-[#00000033] text-darkblue age-groups__input"  
        type="number"
        oninput="this.value = this.value.replace(/[^0-9]/g, '')"
        min="0"
        maxlength="2">
      </div>
      <div class="flex items-center ml-2 w-[18px] h-[18px]"></div>
    </div>
    </div>
    `;
    }
    else {
        container.innerHTML = `
      <div class="age-groups__field-container touch-manipulation">
        <label for="" class="text-darkblue font-semibold">
          <p class="mb-3 touch-none">Inserisci l'età</p>
        </label>
        <div class="flex">
          <div class="relative flex-1">
            <input id="${elementId}" 
            autocomplete="off" 
            name="coverageType" 
            placeholder="Inserisci l'età"
            maxlength="2"
            min="0"
            oninput="this.value = this.value.replace(/[^0-9]/g, '')"
            class="font-semibold relative py-3 px-4 rounded-md border-2 border-[#00000033] outline-none w-full placeholder:text-[#00000033] text-darkblue age-groups__input" 
            type="number">
          </div>
          <div class="flex items-center ml-2">
            <svg class="fill-darkblue lg:cursor-pointer hover:text-active age-groups__remove-field-btn" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_266_4561)">
                <path d="M9 18C6.61305 18 4.32387 17.0518 2.63604 15.364C0.948211 13.6761 0 11.3869 0 9C0 6.61305 0.948211 4.32387 2.63604 2.63604C4.32387 0.948211 6.61305 0 9 0C11.3869 0 13.6761 0.948211 15.364 2.63604C17.0518 4.32387 18 6.61305 18 9C18 11.3869 17.0518 13.6761 15.364 15.364C13.6761 17.0518 11.3869 18 9 18ZM9 16.2C10.9096 16.2 12.7409 15.4414 14.0912 14.0912C15.4414 12.7409 16.2 10.9096 16.2 9C16.2 7.09044 15.4414 5.25909 14.0912 3.90883C12.7409 2.55857 10.9096 1.8 9 1.8C7.09044 1.8 5.25909 2.55857 3.90883 3.90883C2.55857 5.25909 1.8 7.09044 1.8 9C1.8 10.9096 2.55857 12.7409 3.90883 14.0912C5.25909 15.4414 7.09044 16.2 9 16.2ZM13.5 8.1V9.9H4.5V8.1H13.5Z" fill="currentColor"/>
              </g>
              <defs>
                <clipPath id="clip0_266_4561">
                  <rect width="18" height="18" fill="currentColor"/>
                </clipPath>
              </defs>
            </svg>
          </div>
        </div>
      </div>`;
        const removeButton = container.querySelector('.age-groups__remove-field-btn');
        removeButton.addEventListener('click', () => {
            const parentContainer = removeButton.closest('.age-groups__field-container');
            if (parentContainer) {
                parentContainer.remove();
                removeField(elementId, form);
                showAddMore();
            }
        });
    }
    watchAgeFields(form, container.querySelector('.age-groups__input'));
    return container.firstElementChild;
}
export function updateGroupCount(form) {
    const takenGrpFieldNames = [];
    const allInputFields = document.querySelectorAll('.age-groups__input');
    let invalidAgeExists = false;
    let belowZeroAgeExists = false;
    let notANumberExists = false;
    allInputFields.forEach((inputField) => {
        const fieldValue = parseInt(inputField.value, 10);
        if (fieldValue > 74) {
            invalidAgeExists = true;
        }
        if (fieldValue < 0) {
            belowZeroAgeExists = true;
        }
        if (isNaN(fieldValue)) {
            notANumberExists = true;
        }
        takenGrpFieldNames.push(inputField.id);
    });
    const errorBox = document.querySelector('.qq-packages-type--variant');
    if (invalidAgeExists || belowZeroAgeExists || notANumberExists) {
        errorBox.classList.add('error');
    }
    else {
        errorBox.classList.remove('error');
    }
    // value should only be between 0 and 74
    if (invalidAgeExists) {
        ageErrrBox.textContent = ERR_MSGS.errorMsgMaxAge;
        return;
    }
    else if (belowZeroAgeExists) {
        ageErrrBox.textContent = ERR_MSGS.errorMSG_LowAgeValue;
        return;
    }
    else if (notANumberExists) {
        ageErrrBox.textContent = ERR_MSGS.errorMSG_OnlyNumbers;
        return;
    }
    else {
        ageErrrBox.textContent = ERR_MSGS.errorMsgNone;
    }
}
